import YouTubePlayer from 'youtube-player';

export default function WatchVideoBtn(el, {
    actions,
    events,
    markup,
    videoId,
    videoPlayer,
}) {
    // Ensure 16:9 video always fits in viewport
    function resizeVideo(cont) {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const aspectRatio = 16 / 9;

        let width = vw * 0.9;
        let height = width / aspectRatio;

        if (height > vh * 0.9) {
            height = vh * 0.9;
            width = height * aspectRatio;
        }

        cont.style.width = `${width}px`;
        cont.style.height = `${height}px`;
    }

    el.addEventListener('click', () => {
        events.emit(actions.loadModal, { markup });

        if (videoPlayer.value === 'youtube') {
            const player = document.getElementById('youtube-player');

            const youtubePlayer = YouTubePlayer(player, {
                videoId,
                playerVars: {
                    autoplay: 1,
                },
            });

            events.on(actions.closeModal, () => youtubePlayer.pauseVideo());
            resizeVideo(player);
            window.addEventListener('resize', () => resizeVideo(player));
        }

        if (videoPlayer.value === 'vimeo') {
            const cont = document.getElementById('vimeo-player');

            const playerVimeo = new Vimeo.Player(cont, { // eslint-disable-line no-undef
                id: videoId, autoplay: 1, mute: 0, loop: 0,
            });

            events.on(actions.closeModal, () => playerVimeo.pause());
            resizeVideo(cont);
            window.addEventListener('resize', () => resizeVideo(cont));
        }
    });
}
